import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08b2c5b0")

_pushScopeId("data-v-08b2c5b0")
const _hoisted_1 = { class: "crm-customer-chat-message-popup" }
const _hoisted_2 = { class: "crm-customer-chat-message-popup-header" }
const _hoisted_3 = { class: "crm-customer-chat-message-popup-body" }
const _hoisted_4 = {
  style: {"font-size":"14px","color":"#19294F"},
  class: "pb-2"
}
const _hoisted_5 = { class: "crm-customer-chat-message-popup-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpen = $event))
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("i", {
          class: "icon-f icon-delete-cross fs-16 close-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('crm-customer-chat-message-popup.header1')), 1),
          _createVNode("div", null, _toDisplayString(_ctx.$t('crm-customer-chat-message-popup.header2', [_ctx.crmCustomerFullName])), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('label.content')), 1),
          _withDirectives(_createVNode("textarea", {
            maxlength: "200",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.message = $event))
          }, null, 512), [
            [_vModelText, _ctx.message]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _toDisplayString(_ctx.$t('button.cancel')), 1),
          _createVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendMsg && _ctx.sendMsg(...args)))
          }, _toDisplayString(_ctx.$t('button.send')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
})